import api from './api';
import {
  BicycleFloorListResponse,
  BicycleAddonListResponse,
  BicycleTypeListResponse,
  BicycleSpaceListResponse,
  BicycleFloor,
  BicycleAddon,
  BicycleType,
  BicycleSpace
} from '../types/bicycle';

// Bicycle Floors
export const bicycleFloorService = {
  getAll: async (workspaceId: string, params?: any): Promise<BicycleFloorListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/bicycle-floors`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ bicycleFloor: BicycleFloor }> => {
    const response = await api.get(`/workspaces/${workspaceId}/bicycle-floors/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ bicycleFloor: BicycleFloor }> => {
    const response = await api.post(`/workspaces/${workspaceId}/bicycle-floors`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ bicycleFloor: BicycleFloor }> => {
    const response = await api.put(`/workspaces/${workspaceId}/bicycle-floors/${id}`, data);
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/bicycle-floors/${id}`);
  },

  uploadLayout: async (workspaceId: string, floorId: string, layoutData: any): Promise<{ bicycleFloor: any }> => {
    const response = await api.post(`/workspaces/${workspaceId}/bicycle-floors/${floorId}/layout`, layoutData);
    return response.data;
  }
};

// Bicycle Add-ons
export const bicycleAddonService = {
  getAll: async (workspaceId: string, params?: any): Promise<BicycleAddonListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/bicycle-addons`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ bicycleAddon: BicycleAddon }> => {
    const response = await api.get(`/workspaces/${workspaceId}/bicycle-addons/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ bicycleAddon: BicycleAddon }> => {
    const response = await api.post(`/workspaces/${workspaceId}/bicycle-addons`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ bicycleAddon: BicycleAddon }> => {
    const response = await api.put(`/workspaces/${workspaceId}/bicycle-addons/${id}`, data);
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/bicycle-addons/${id}`);
  }
};

// Bicycle Types
export const bicycleTypeService = {
  getAll: async (workspaceId: string, params?: any): Promise<BicycleTypeListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/bicycle-types`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ bicycleType: BicycleType }> => {
    const response = await api.get(`/workspaces/${workspaceId}/bicycle-types/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ bicycleType: BicycleType }> => {
    const response = await api.post(`/workspaces/${workspaceId}/bicycle-types`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ bicycleType: BicycleType }> => {
    const response = await api.put(`/workspaces/${workspaceId}/bicycle-types/${id}`, data);
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/bicycle-types/${id}`);
  }
};

// Bicycle Spaces
export const bicycleSpaceService = {
  getAll: async (workspaceId: string, params?: any): Promise<BicycleSpaceListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/bicycle-spaces`, { params });
    return response.data;
  },

  getByFloor: async (workspaceId: string, floorId: string, params?: any): Promise<BicycleSpaceListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/bicycle-spaces/by-floor/${floorId}`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ bicycleSpace: BicycleSpace }> => {
    const response = await api.get(`/workspaces/${workspaceId}/bicycle-spaces/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ bicycleSpace: BicycleSpace }> => {
    const response = await api.post(`/workspaces/${workspaceId}/bicycle-spaces`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ bicycleSpace: BicycleSpace }> => {
    const response = await api.put(`/workspaces/${workspaceId}/bicycle-spaces/${id}`, data);
    return response.data;
  },

  bulkUpdate: async (workspaceId: string, updates: any[]): Promise<{ updated: number }> => {
    const response = await api.put(`/workspaces/${workspaceId}/bicycle-spaces/bulk-update`, { updates });
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/bicycle-spaces/${id}`);
  },

  bulkCreate: async (workspaceId: string, spaces: any[]): Promise<{ bicycleSpaces: any[]; count: number; message: string }> => {
    const response = await api.post(`/workspaces/${workspaceId}/bicycle-spaces/bulk-create`, { spaces });
    return response.data;
  }
};
